export var ASAccountType;
(function (ASAccountType) {
    ASAccountType[ASAccountType["INCOME"] = 1] = "INCOME";
    ASAccountType[ASAccountType["EXPENSE"] = 2] = "EXPENSE";
})(ASAccountType || (ASAccountType = {}));
//# sourceMappingURL=as-account-type.js.map